import { useUser } from "@auth";
import { CelebrationsMainPageTemplateProps } from "./template";
import { useNavigate } from "react-router-dom";

export const useCelebrationsMainPage = (): CelebrationsMainPageTemplateProps => {
    const navigate = useNavigate();
    const partner = useUser();
    

    const navigateToPage = (index: number, to: string) => {
        navigate(to);
      }

    return {
        premiumUsers: partner?.premiumSettings?.[0]?.users.filter(item => item.userId !== "") || [],
        navigateToPage,
    }
}